import React from "react";
import { Box } from "@mui/material";
import { endOfYear, getDayOfYear, startOfYear } from "date-fns";
import { useOcCalendar } from "oc/hooks";

interface MyLeaveCalendarTimelineDateHeaderProps {
  date: Date;
  label: string;
  isOffRange: boolean;
}

export const MyLeaveCalendarTimelineDateHeader = ({
  date,
  label,
  isOffRange,
}: MyLeaveCalendarTimelineDateHeaderProps) => {
  let startDate = startOfYear(date);
  let endDate = endOfYear(date);

  const { data: Calendar } = useOcCalendar({ startDate, endDate });
  let day = getDayOfYear(date);
  let dayState = Calendar.charAt(day - 1);

  let color = "#212121";
  if (isOffRange) {
    color = "#ffffff";
  }
  if (dayState === "F") {
    color = "#cc0033";
  }

  return (
    <Box style={{ textAlign: "center" }}>
      <span
        style={{
          fontSize: 12,
          fontWeight: "normal",
          color: color,
        }}
      >
        {label}
      </span>
    </Box>
  );
};

export default MyLeaveCalendarTimelineDateHeader;
